import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { StorageHelper } from '../../../utils/StorageHelper';
import { useAppStore } from '../../../store/AppContext';
import useAPIError from '../../../hooks/useAPIError';
import DataService from '../../../services/MisDatosService';
import { ErrorCodeConstants } from '../../../utils/ErrorCodeConstants';
import ModalConfirmacion from '../../../components/ModalConfirmacion';
import { FooterConstants } from '../../../utils/FooterConstants';
import { useMisDatosStore } from '../../MisDatos/context/MisDatos.context';
import HandlePrevalidacionError from '../../../utils/PrevalidacionErrorHandler';
import routerLoader from '../../../i18n/router';

interface Props {
  hittype: string;
  event_category: string;
  event_action: string;
  event_label: string;
}

const WaMenuSocioClubLink: FC<Props> = (props) => {
  const { event_action, event_category, event_label, hittype } = props;
  const dataApp = useAppStore();
  const {
    showModalTelefono1,
    showModalContactEmail,
    showFlagTelefono1Incorrecto,
    hideModalV2P,
  } = useMisDatosStore();
  const { access, lang, handleModalDatosPersonales } = dataApp;
  const [showError, setShowError] = useState(false);
  const [showDniError, setShowDniError] = useState(false);
  const [messageError, setMessageError] = useState('');
  const [typeError, setTypeError] = useState<number>();
  const location = useLocation();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { addError } = useAPIError();
  const { t } = useTranslation();
  const APP_BASE_URL = document.location.hostname.includes('eroski.es')
    ? process.env.REACT_APP_BASE_URL
    : process.env.REACT_APP_BASE_URL_CAPRABO;
  const getHTMLContent = () => {
    return `${t(
      'tarjetas.tarjeta-socio.error-AME-sac-prevalidation-message',
    )} <a href="tel:944943444" style="color: #4a90e2; text-decoration: none;">${
      FooterConstants.TELEFONO_ATENCION_CLIENTE
    }.</a>`;
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault(); // Prevenir la acción por defecto del enlace

    DataService.checkPrevalidacionDatosAltaClub()
      .then((responsePrevalidacion) => {
        if (responsePrevalidacion.data.error) {
          HandlePrevalidacionError(responsePrevalidacion.data.errorCode, {
            setMessageError,
            setShowError,
            setTypeError,
            setShowDniError,
            t,
          });
        } else {
          StorageHelper.deleteUserFromSessionAndRedirect(
            access.solicitarTarjeta,
            lang,
            APP_BASE_URL,
            e,
            '',
          );
        }
      })
      .catch((er: any) => {
        console.log(er);
        setMessageError(t('nlr-vaya-algo-no-ha-ido-bien'));
        setShowError(true);
      });
  };

  const goToMisDatosAndOpenModal = () => {
    if (location.pathname.includes('mis-datos')) {
      if (
        typeError ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION
      ) {
        const formDireccion = document.querySelector(
          '[id^="habitual-"]',
        ) as HTMLFormElement;
        if (formDireccion) {
          formDireccion.classList.add('visible');
          const submitButtons = document.querySelectorAll(
            '[id^="direccion-submit-btn-"]',
          );
          const button = submitButtons[0] as HTMLElement;
          button.click();
        }
      } else if (
        typeError ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
      ) {
        StorageHelper.setOpenAltaClubPersonalData();
        handleModalDatosPersonales(true);
      } else if (
        typeError ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_TELEFONO_EXCEPTION
      ) {
        showModalTelefono1();
        showFlagTelefono1Incorrecto();
      } else if (
        typeError ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_EMAIL_EXCEPTION
      ) {
        showModalContactEmail();
      }
    } else {
      if (
        typeError ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_DIRECCION_EXCEPTION
      ) {
        StorageHelper.setOpenV2PFromOro();
        StorageHelper.setOpenDireccionHabitual();
      }
      if (
        typeError ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
      ) {
        StorageHelper.setOpenV2PFromOro();
        StorageHelper.setOpenOroPersonalData();
      }
      if (
        typeError ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_MISDATOS_EXCEPTION
      ) {
        StorageHelper.setOpenV2PFromOro();
        StorageHelper.setOpenOroPersonalData();
      }
      if (
        typeError ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_TELEFONO_EXCEPTION
      ) {
        StorageHelper.setOpenTelefonoError();
      }
      if (
        typeError ===
        ErrorCodeConstants.UPDATE_DATOSACCESO_DOBLE_VERIFICACION_VALIDATIONS_EMAIL_EXCEPTION
      ) {
        showModalContactEmail();
      }
      hideModalV2P();
      window.location.href = routerLoader.LoadRouterByPath(
        'mis-datos',
        dataApp.lang,
      );
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const emptymethod = () => {
    StorageHelper.removeOpenAltaClubPersonalData();
    handleModalDatosPersonales(false);
  };
  return (
    <>
      <div className="icon-link-block">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          data-wa-hittype={hittype}
          data-wa-event-category={event_category}
          data-wa-event-action={event_action}
          data-wa-event-label={event_label}
          href=""
          onClick={handleClick}
          className="icon-link icon-link__oro"
        >
          <img src={access.solicitarTarjeta?.urlImagen} alt="" />
          <span>{access.solicitarTarjeta?.descripcion}</span>
        </a>
      </div>
      <ModalConfirmacion
        isBig={false}
        isSmall
        textCentered
        showModal={showError}
        setShowModal={setShowError}
        title=""
        textHTMLContent={t(messageError)}
        doAceptar={goToMisDatosAndOpenModal}
        doClose={emptymethod}
        showCancel={false}
        acceptButtonTextKey={t('datos.accessdata.accept')}
        hideXButton
      />
      <ModalConfirmacion
        isBig={false}
        isSmall
        textCentered
        showModal={showDniError}
        setShowModal={setShowDniError}
        title={t('nlr-vaya-algo-no-ha-ido-bien')}
        textHTMLContent={getHTMLContent()}
        doAceptar={() => null}
        doClose={emptymethod}
        showCancel={false}
        acceptButtonTextKey={t('entendido')}
        hideXButton
      />
    </>
  );
};

export default WaMenuSocioClubLink;
